import React, { useEffect, useState } from "react";
import logo from "../assets/Transparent-LogoZugeschnitten.png";

const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  // Scrollverhalten überwachen
  useEffect(() => {
    const handleScroll = () => {
      const isMobile = window.innerWidth <= 1024;

  
      if (isMobile) {
        if (window.scrollY > lastScrollY && window.scrollY > 100) {
          setShowNavbar(false); // runter -> ausblenden
        } else {
          setShowNavbar(true);  // hoch -> einblenden
        }
      } else {
        setShowNavbar(true); // auf Desktop immer anzeigen
      }
  
      setLastScrollY(window.scrollY);
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // Mobile Menü Toggle
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    setShowNavbar(true); // immer anzeigen wenn geöffnet wird
  };
  //href ist angepasst!
  return (
    <nav className={`navbar ${showNavbar ? "visible" : "hidden"} ${menuOpen ? "menu-open" : ""}`}>
      <div className="logo-container">
        <img src={logo} alt="Qlance Logo" className="logo" />
      </div>
      <div className={`nav-container ${menuOpen ? "show-menu" : ""}`}>
      <ul className={`nav-links ${showNavbar ? "show-links" : "hide-links"} ${menuOpen ? "mobile-open" : ""}`}>
          <li className="nav-cta-wrapper">
            <button
              className="nav-start-btn"
              onClick={() =>
                document.getElementById("contact")?.scrollIntoView({
                  behavior: "smooth",
                })
              }
            >
              <div>JETZT STARTEN</div>
            </button>
          </li>
          <li><a href="#start-scroll">Home</a></li>
          <li><a href="#kpi">Fakten</a></li>
          <li><a href="#timeline-scroll">Ablauf</a></li>
          <li><a href="#projekt-scroll">Projekte</a></li>
          <li><a href="#network-scroll">Netzwerk</a></li>
          <li><a href="#founder-team">Team</a></li>
          <li><a href="#contact">Kontakt</a></li>
        </ul>
      </div>
      <button className={`nav-toggle ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
      </button>
    </nav>
  );
};

export default Navbar;
